import { render, staticRenderFns } from "./file-access.vue?vue&type=template&id=414df72e&scoped=true"
import script from "./file-access.vue?vue&type=script&lang=js"
export * from "./file-access.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414df72e",
  null
  
)

export default component.exports